import { DossierDto } from '@resources/resources';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'facturation-detail-resultat',
  templateUrl: './facturation-detail-resultat.component.html'
})
export class FacturationDetailResultatComponent {

  @Input() dossier: DossierDto;

  prixTotal: number = 0;

  elementsValorisation: Array<{ name: string, value: number }> = [];
  valorisationTotal: number = 0;

  ngOnChanges() {
    this.calculerPrixTotal();
    this.findElementsValorisation();
  }

  private findElementsValorisation() {
    if (this.dossier.montantPatient) {
      this.elementsValorisation.push({
        name: "PAGE.DETAIL-RESULTAT.FACTURE.montantPatient",
        value: this.dossier.montantPatient
      });
      this.valorisationTotal += this.dossier.montantPatient;
    }
    if (this.dossier.montantAutre) {
      this.elementsValorisation.push({
        name: "PAGE.DETAIL-RESULTAT.FACTURE.montantAutre",
        value: this.dossier.montantAutre
      });
      this.valorisationTotal += this.dossier.montantAutre;
    }
    if (this.dossier.montantLabo) {
      this.elementsValorisation.push({
        name: "PAGE.DETAIL-RESULTAT.FACTURE.montantLabo",
        value: this.dossier.montantLabo
      });
      this.valorisationTotal += this.dossier.montantLabo;
    }
    if (this.dossier.montantMutuelle) {
      this.elementsValorisation.push({
        name: "PAGE.DETAIL-RESULTAT.FACTURE.montantMutuelle",
        value: this.dossier.montantMutuelle
      });
      this.valorisationTotal += this.dossier.montantMutuelle;
    }
    if (this.dossier.montantSS) {
      this.elementsValorisation.push({
        name: "PAGE.DETAIL-RESULTAT.FACTURE.montantSS",
        value: this.dossier.montantSS
      });
      this.valorisationTotal += this.dossier.montantSS;
    }
  }

  private calculerPrixTotal() {
    this.prixTotal = 0;
    if (this.dossier.nomenclatures != null && this.dossier.nomenclatures.length > 0) {
      this.dossier.nomenclatures.forEach((nomenclature) => {
        this.prixTotal += nomenclature.prix;
      });
    }
    this.prixTotal = Number(this.prixTotal.toFixed(2));
  }

}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-serveur-resultats/digicerba-serveur-resultats-web/src/angular/cerba/src/app/pages/cerba/pages/detail-resultat/body/facturation/facturation-detail-resultat.component.ts